import React from 'react';

import {Typography} from '@mui/material';
import {
  Stack,
} from '@zoom/react-ui';
import {useTranslation} from 'react-i18next';

import {ZmSwitch} from 'Components/ZmInputs/index.js';

/**
 * Time format 12h/24h switch
 * @param {Object} props
 * @return {ReactElement}
 */
export default function TimeFormatSwitch(props) {
  const {
    handleChangeTimeFormat,
    sx,
    timeFormat,
  } = props;
  const {t} = useTranslation();

  const handleToggle = (e) => {
    const newValue = e.target.checked ? '24h' : '12h';
    // saved time format setting for booker
    localStorage.setItem('timeFormat', newValue);
    handleChangeTimeFormat(newValue);
  };

  return <Stack direction="row" sx={sx}>
    <ZmSwitch
      size="small"
      checked={timeFormat === '24h'}
      onChange={handleToggle}
      onKeyDown={handleToggle}
    />
    <Typography sx={{marginLeft: '8px', whiteSpace: 'nowrap', fontSize: '0.875rem'}}>
      {t('integration.24Hr')}
    </Typography>
  </Stack>;
}
